















import {namespace} from 'vuex-class';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {CART} from '@/store/types';
import {Cart} from '@/services/cart/model/cart';
import {DependencyService} from '@/services/DependencyService';
import { ProductDto } from '@eurogast/hub-client-typescript';

const cart = namespace(CART);

@Component
export default class ShoppingCartButton extends Vue {

  @Prop({required: false, default: '/my/shopping-cart'})
  public localPathToCart: string;

  @cart.State('cart')
  public cart: Cart;

  private cartService = DependencyService.getCartService();

  public mounted() {
    this.cartService.fetchCart();
  }

  get availableCartItemLength(): number {
    return this.cart.items.filter((it) => it.product.availability === ProductDto.AvailabilityEnum.ACTIVE).length;
  }
}
